import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

const isDev = window.location?.hostname === 'localhost'
	|| window.location?.hostname === '127.0.0.1'
	|| window.location?.hostname?.startsWith('192.168.');

type DebugCutoutFeatureParams = FeatureHoookParams;
export const useDebugCutoutFeature = (_params: DebugCutoutFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { debugCutouts: boolean }}>();

	useSubscription(controller, false, [['layer-option-debug-cutout', '*']]);

	const controllerSupportsFeature = (controller?.options?.debugCutouts ?? null) !== null;
	const showLayer = controller?.options?.debugCutouts ?? false;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} Debug Cutouts`;
	})();

	return {
		name: 'debugCutouts',
		label: 'Debug Cutouts',
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: !isDev,
		handler: () => {
			if (controller) {
				controller.options.debugCutouts = !showLayer;
			}
		}
	};
};
